import React from 'react'
import RawMenuItem from '@mui/material/MenuItem'

const MenuItem = ({value, children, ...p}) => {
    return (
        <RawMenuItem value={value} {...p}>
            {children}
        </RawMenuItem>
    )
}

export default MenuItem
